import "./vehicle-tile-horizontal.scss";

import React from "react";
import { Link } from "gatsby";
import classNames from "classnames";
import { addSpaceInNumbers } from "../../utils";

const VehicleTileHorizontal = ({
  thumbnail,
  name,
  price,
  discountPrice,
  discount,
  label,
  labelColor,
  labelName,
  used,
  type,
  url,
  desc,
}) => {
  return (
    <div
      className={classNames(`vehicle-tile-horizontal`, {
        [`vehicle-tile-horizontal--used`]: used === "used",
      })}
    >
      <div
        className="vehicle-tile-horizontal__thumbnail"
        style={{ backgroundImage: `url(${thumbnail})` }}
      />
      <div className="vehicle-tile-horizontal__content-container">
        <div>
          <div className="vehicle-tile-horizontal__type">
            {type === "przyczepa"
              ? "Przyczepa"
              : type === "kampervan"
              ? "Kamper-van"
              : type === "polintegra"
              ? "Pół-integra"
              : "Integra"}
          </div>
          <div className="vehicle-tile-horizontal__name">
            {name}
            {/* {label || used ? (
              <div
                className="vehicle-tile-horizontal__label"
                style={{ backgroundColor: used ? "C59B6D" : labelColor }}
              >
                {used ? "Używane" : labelName}
              </div>
            ) : (
              ""
            )} */}
            {label || used === "used" ? (
              <div
                className="vehicle-tile-horizontal__label"
                style={{
                  backgroundColor: used === "used" ? "C59B6D" : labelColor,
                }}
              >
                {used === "used" ? "Używane" : labelName}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="vehicle-tile-horizontal__price-container">
            {discount ? (
              <div className="vehicle-tile-horizontal__price">
                {addSpaceInNumbers(discountPrice)} PLN <span>{price}</span>
              </div>
            ) : (
              <div className="vehicle-tile-horizontal__price">
                {addSpaceInNumbers(price)} PLN
              </div>
            )}
          </div>
          <div
            className="vehicle-tile-horizontal__desc"
            dangerouslySetInnerHTML={{ __html: desc }}
          />
        </div>
        <Link
          to={url}
          className="btn btn--rounded-small vehicle-tile-horizontal__btn"
        >
          Sprawdź!
        </Link>
      </div>
    </div>
  );
};

export default VehicleTileHorizontal;
